import { Input } from "./Input";
import InputStyles from "./Input.styles";
import BaseField from "./Base";
export default Input;

export {
    BaseField,
    InputStyles
}